import { render } from "./AgregarReceta.vue?vue&type=template&id=cb0e2874&scoped=true"
import script from "./AgregarReceta.vue?vue&type=script&lang=js"
export * from "./AgregarReceta.vue?vue&type=script&lang=js"

import "./AgregarReceta.vue?vue&type=style&index=0&id=cb0e2874&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0e2874"]])

export default __exports__